// components/GetInvolved.js
import React from 'react';
import './GetInvolved.css';

const GetInvolved = () => {
  return (
    <section className="get-involved">
      <div className="container">
        <h2 className="section-title">Get Involved</h2>
        <div className="involvement-options">
          <div className="option-card">
            <div className="card-icon">🤝</div>
            <h3>Volunteer</h3>
            <p>Join our team of dedicated volunteers and make a direct impact</p>
            <button className="btn btn-primary">Sign Up</button>
          </div>
          <div className="option-card featured">
            <div className="card-icon">💰</div>
            <h3>Donate</h3>
            <p>Your contribution helps us reach more communities in need</p>
            <button className="btn btn-primary">Donate Now</button>
          </div>
          <div className="option-card">
            <div className="card-icon">🤝</div>
            <h3>Partner</h3>
            <p>Corporate partnerships for sustainable social impact</p>
            <button className="btn btn-primary">Learn More</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInvolved;